import { ValidationErrors } from "@angular/forms";

export type ValidationKey = 'required' | 'stringLatin' | 'maxlength' | 'minlength';

export interface RequiredValidationMessage {
    key: 'required',
    message: string,
}

export interface StringLatinValidationMessage {
    key: 'stringLatin',
    message: string,
}

export interface MaxLengthValidationMessage {
    key: 'maxlength',
    message: string,
    maxLength?: number,
    currentLength?: number;
}

export interface MinLengthValidationMessage {
    key: 'minlength',
    message: string,
    minLength?: number,
    currentLength?: number;
}

export type ValidationMessage = RequiredValidationMessage | StringLatinValidationMessage | MaxLengthValidationMessage | MinLengthValidationMessage;
export function appendErrorInfos(messages: ValidationMessage, errors: ValidationErrors): ValidationMessage {
    switch(messages.key) {
        case 'minlength':
            if (!messages.currentLength) {
                messages.currentLength = errors[messages.key]?.actualLength || 0;
            }
            if (!messages.minLength) {
                messages.minLength = errors[messages.key]?.requiredLength || 0;
            } 
            break;
        case 'maxlength':
            if (!messages.currentLength) {
                messages.currentLength = errors[messages.key]?.actualLength || 0;
            }
            if (!messages.maxLength) {
                messages.maxLength = errors[messages.key]?.requiredLength || 0;
            }
            break;
    }
    return messages;
}

export function createErrorMessage(message: ValidationMessage): string {
    switch(message.key) {
      case 'maxlength':
        return `${message.message} (${message.currentLength || 0}/${message.maxLength || 0})`;
      case 'minlength':
        return `${message.message} (${message.currentLength || 0}/${message.minLength || 0})`;
    }
    return message.message;
}